// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-d189c3","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-7487c5","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-b5fc37"};